import { render } from "./ViewerCallTest.vue?vue&type=template&id=0b42d9a2&scoped=true"
import script from "./ViewerCallTest.vue?vue&type=script&lang=js"
export * from "./ViewerCallTest.vue?vue&type=script&lang=js"

import "./ViewerCallTest.vue?vue&type=style&index=0&id=0b42d9a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b42d9a2"]])

export default __exports__